import { useEffect, useMemo, useState } from 'react'
import { Button, Table } from '..'

import { PlusSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'
import { useModalBox } from '../../contexts'
import RegisterModal from './register-modal'
import { fetchTestXConstruct } from '../../../main/usecases/admin-menu/test-x-contruct'
import { testXConstructsModel } from '../../../domain/models/admin-models'

const ConstructXTest = () => {
  const [page, setPage] = useState(1)
  const { modalBox } = useModalBox()
  const [testXConstructData, setTesteXConstructData] =
    useState<testXConstructsModel>()

  useEffect(() => {
    ;(async () => {
      const relationship = await fetchTestXConstruct(page).load()
      setTesteXConstructData(relationship)
    })()
  }, [page])
  const columns = useMemo(
    () => [
      {
        Header: 'Código teste',
        accessor: 'nameToCodigoTeste'
      },
      {
        Header: 'Teste',
        accessor: 'nameToTeste'
      },
      {
        Header: 'Código construto',
        accessor: 'nameToConstrutoCodigo'
      },
      {
        Header: 'Construto',
        accessor: 'nameToConstruto'
      }
    ],
    []
  )
  const data = useMemo(() => {
    return testXConstructData?.content?.map((item) => {
      return {
        nameToCodigoTeste: item[0],
        nameToTeste: item[1],
        nameToConstrutoCodigo: item[2],
        nameToConstruto: item[3]
      }
    })
  }, [testXConstructData?.content])
  return (
    <S.Wrapper>
      <S.Title>Cadastro teste X construtos</S.Title>
      <S.Body>
        <Button
          initialIcon={<PlusSvg />}
          onClick={() =>
            modalBox(<RegisterModal />, 'Cadastro teste x construto', '38%')
          }
        >
          Novo cadastro
        </Button>
        <S.TableContainer>
          <Table
            onClick={() => ({})}
            columns={columns}
            dataTable={data || []}
            pageCount={testXConstructData?.totalPages}
            handlePageClick={(currentPage: any) =>
              setPage(currentPage.selected + 1)
            }
          />
        </S.TableContainer>
      </S.Body>
    </S.Wrapper>
  )
}
export default ConstructXTest
